import type {Result} from 'framework';
import type {OnboardingStatus} from '../domain/onboarding-status.value-object';
import type {CheckOnboardingStatus} from '../application/use-cases/check-onboarding-status';
import type {CompleteOnboarding} from '../application/use-cases/complete-onboarding';

export class OnboardingController {
  constructor(
    private readonly checkOnboardingStatusUseCase: CheckOnboardingStatus,
    private readonly completeOnboardingUseCase: CompleteOnboarding,
  ) {}

  getStatus(): Promise<Result<OnboardingStatus>> {
    return this.checkOnboardingStatusUseCase.execute();
  }

  complete(): Promise<Result<void>> {
    return this.completeOnboardingUseCase.execute();
  }
}
